<template>
  <div class="eventsConfigWrap">
    <div v-if="curComponent.component === 'Video'" class="video-event-container">
      <div class="label attr-action-head">
        <span>
          <AttrHelpDot help-key="event.videoBind" />
          {{ $tt("绑定事件") }}
        </span>
        <el-button type="text" icon="el-icon-plus" class="attr-add-btn" @click="addDirectives">{{ $tt("添加") }}</el-button>
      </div>
      <div class="video-event-item" v-for="(item, itemInd) in curComponent.events.instructionDatas" :key="item.id">
        <div style="margin-bottom: 10px;">
          {{ $tt("当视频播放到第") }}
            <el-input-number
              v-model="item.time"
              :controls="false"
              :min="0"
              :step="1"
              :precision="0"
              size="mini"
            />
          {{ $tt("秒") }}
        </div>
        <div @click="directivesClick(item)">
          <el-button type="text" icon="el-icon-plus" class="attr-add-btn">{{ $tt("添加指令") }}</el-button>
          <div class="directives">
            <el-tag
              type="info"
              v-for="d in item.instructions"
              :key="d.order"
              closable
              @close="deleteDirective(d, itemInd)"
              >{{ d.instruction_name }}</el-tag
            >
          </div>
        </div>
        <i class="el-icon-delete video-event-item-delete" v-if="itemInd !== 0" @click="deleteItem(itemInd)"></i>
      </div>
    </div>
    <div v-else class="div-events">
      <div class="label">
        <AttrHelpDot help-key="section.events" />
        {{ $tt("绑定事件") }}
      </div>
      <div
        class="event-summary-card"
        :class="{ 'is-set': eventSummary(e.key).set }"
        v-for="e in buttonEventsConfig"
        :key="e.key"
        @click="btnClickedHandler(e)"
      >
        <div class="event-summary-head">
          <span class="event-summary-title">
            <AttrHelpDot :help-key="'event.' + e.key" />
            {{ $tt(e.text) }}
          </span>
          <el-tag v-if="eventSummary(e.key).set" size="mini" type="success">
            {{ eventSummary(e.key).count }}
          </el-tag>
          <el-tag v-else size="mini" type="info">{{ $tt("未设置") }}</el-tag>
        </div>
        <div class="event-summary-text">{{ eventSummary(e.key).text }}</div>
      </div>
    </div>
    <div v-if="curComponent.component === 'v-button' && curComponent.style.oneClick">
      <div class="label attr-action-head">
        <span>
          <AttrHelpDot help-key="event.clickBind" />
          {{ $tt("点击绑定") }}
        </span>
        <el-tag v-if="clickSummary.set" size="mini" type="success">{{ $tt("已设置") }}</el-tag>
        <el-tag v-else size="mini" type="info">{{ $tt("未设置") }}</el-tag>
      </div>
      <div class="event-summary-text click-bind-summary">{{ clickSummary.text }}</div>
      <div>
        <div class="click-bind-item">
          <el-select
              v-model="curComponent.events.clickEvent.comp"
              :placeholder="$tt('请选择绑定组件')"
              @change="clickCompChange"
              :clearable="true"
          >
              <el-option
                  v-for="comp in allComps"
                  :key="comp.value"
                  :label="$tt(comp.label)"
                  :value="comp.value"
                  @mouseenter.native="handleEventCompHover(comp)"
                  @mouseleave.native="handleEventCompLeave(comp)"
              >
              </el-option>
          </el-select>
        </div>
        <div class="click-bind-item">
          <el-select
              v-model="curComponent.events.clickEvent.event"
              :placeholder="$tt('请选择事件')"
              :clearable="true"
          >
              <el-option
                  v-for="comp in compEventOptions"
                  :key="comp.value"
                  :label="$tt(comp.label)"
                  :value="comp.value"
              >
              </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <BindEventsModal :activeEventType="activeEventType" ref="bindEventsModal" />

    <!-- 选择指令 -->
    <DirectivesModal :modalType="3" :directivesDatas="directivesDatas" ref="directivesModal" @confirm="directivesConfirm" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import BindEventsModal from "./BindEventsModal.vue";
import DirectivesModal from './DirectivesModal.vue'
import AttrHelpDot from './AttrHelpDot'
import { eventItemSummary, clickBindSummary } from "@/utils/canvasBindSummary";

export default {
  components: { BindEventsModal, DirectivesModal, AttrHelpDot },
  data() {
    return {
      ipAdress: "",
      directivesDatas: [],
      currentInstruction: null,
      buttonEventsConfig: [],
      activeEventType: {
        text: "互斥事件",
        key: "mutuallyEvent",
      },
      clickEventOptions: {
        Video: [
          { label: '开始', value: 'play' },
          { label: '暂停', value: 'pause' },
          { label: '继续', value: 'continue' },
          { label: '停止', value: 'stop' },
          { label: '重播', value: 'replay' },
          { label: '音量加', value: 'volumeUp' },
          { label: '音量减', value: 'volumeDown' },
          { label: '静音', value: 'mute' },
          { label: '解除静音', value: 'unmute' }
        ],
        Carousel: [
          { label: '上一页', value: 'prev' },
          { label: '下一页', value: 'next' },
        ],
        Music: [
          { label: '开始', value: 'play' },
          { label: '暂停', value: 'pause' },
          { label: '继续', value: 'continue' },
          { label: '停止', value: 'stop' },
          { label: '重播', value: 'replay' },
          { label: '音量加', value: 'volumeUp' },
          { label: '音量减', value: 'volumeDown' },
          { label: '静音', value: 'mute' },
          { label: '解除静音', value: 'unmute' }
        ],
        Webpage: [
          { label: '上一步', value: 'prev' },
          { label: '下一步', value: 'next' },
        ]
      },
      allComps: [],
      compEventOptions: []
    };
  },
  computed: {
    ...mapState(["curComponent", "componentData", "canvasAllData", "pageOptions"]),
    clickSummary() {
      return clickBindSummary(this.curComponent, { componentData: this.componentData });
    },
  },
  mounted() {
    this.initEventsAttrs();
  },
  watch: {
    curComponent: {
      handler(v) {
        this.initEventsAttrs(v);
      },
      deep: true,
    },
    componentData: {
      handler: function(val, oldValue) {
          if (val && val.length !== 0) {
              this.getAllComps();
          }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clickCompChange(val) {
      if (val) {
        var compItem = this.allComps.filter(a => a.value === val);
        var component = compItem[0].component;
        this.compEventOptions = this.clickEventOptions[component];
        var isIn = this.compEventOptions.filter(a => a.value === this.curComponent.events.clickEvent.event);
        if (!isIn || isIn.length === 0) {
          this.curComponent.events.clickEvent.event = '';
        }
      } else {
        this.compEventOptions = [];
      }
    },
    handleEventCompHover(item) {
      var currentElem = document.getElementById("component" + item.value);
      currentElem.classList.add("link-select-hover");
    },
    handleEventCompLeave(item) {
      var currentElem = document.getElementById("component" + item.value);
      currentElem.classList.remove("link-select-hover");
    },
    getAllComps() {
      this.allComps = this.componentData.reduce((arr, item) => {
        if (["Video", "Carousel", "Music", "Webpage"].includes(item.component)) {
          arr.push({
            label: item.label,
            value: item.id,
            component: item.component
          });
        }
        return arr;
      }, []);
    },
    addDirectives() {
      var obj = { time: '', instructions: [], id: new Date().valueOf() };
      this.curComponent.events.instructionDatas.push(obj);
    },
    deleteItem(ind) {
      this.curComponent.events.instructionDatas.splice(ind, 1);
    },
    directivesConfirm(data) {
      const ind = this.curComponent.events.instructionDatas.findIndex((item) => item.id === this.currentInstruction);
      this.curComponent.events.instructionDatas[ind].instructions = data;
    },
    deleteDirective(d, itemInd) {
      const tags = this.curComponent.events.instructionDatas[itemInd].instructions;
      const tagInd = tags.findIndex((item) => item.temId === d.temId);
      this.curComponent.events.instructionDatas[itemInd].instructions.splice(tagInd, 1);
    },
    directivesClick(data) {
      this.currentInstruction = data.id;
      this.directivesDatas = data.instructions;
      this.$nextTick(() => {
        this.$refs.directivesModal.switchModalVisible(true);
      })
    },
    eventSummary(key) {
      return eventItemSummary(this.curComponent, key, {
        componentData: this.componentData,
        canvasAllData: this.canvasAllData,
        pageOptions: this.pageOptions,
      });
    },
    btnClickedHandler(e) {
      this.activeEventType = e;
      this.$refs.bindEventsModal.switchModalVisible(true);
    },
    initEventsAttrs(v) {
      let items = [
        {
          text: "互斥事件",
          key: "mutuallyEvent",
        },
        {
          text: "跳转事件",
          key: "jumpEvent",
        },
        {
          text: "联动事件",
          key: "pressEvent",
        },
        {
          text: "再次按压联动事件",
          key: "pressAgainEvent",
        },
      ];
      const { component, style } = v || this.curComponent;
      if (component == "v-button") {
        if (!style.oneClick) {
          items = items.filter((item) => item.key != "jumpEvent");
        }
        if (style.oneClick) {
          items = items.filter((item) => item.key != "pressAgainEvent");
        }
      }
      this.buttonEventsConfig = items;
      this.clickCompChange(this.curComponent.events?.clickEvent?.comp);
    },
  },
};
</script>

<style lang="scss">
.video-event-container {
  .label {
    margin-bottom: 12px;
  }
}
.video-event-item {
  .el-input-number {
    width: 66px;
    .el-input__inner {
      padding: 0px 6px;
      text-align: left;
    }
  }
}
</style>
<style lang="scss" scoped>
.eventsConfigWrap {
  .div-events .label {
    margin: 0 0 12px;
    font-size: 12px;
    color: #606266;
  }
  .event-summary-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px 12px;
    margin: 0 0 10px;
    background: #fafbfc;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, background 0.15s ease;
    &:hover {
      border-color: #c6e2ff;
      background: #f5faff;
    }
    &.is-set {
      border-color: #c6e2ff;
      background: #f0f7ff;
    }
  }
  .event-summary-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .event-summary-title {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
  }
  .event-summary-text {
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.5;
    color: #909399;
    word-break: break-all;
  }
  .eventItem {
    display: flex;
    align-items: center;
    margin: 0 0 12px;
    .attr-event-btn {
      flex: 1;
    }
  }
}
.modalContent {
  height: 100%;
  width: 100%;
  padding: 24px;
}
.video-event-container {
  font-size: 12px;
  .video-event-item {
    border: 1px solid #dadada;
    padding: 10px;
    margin-right: 0;
    position: relative;
    & + .video-event-item {
      margin-top: 12px;
    }
    .video-event-item-delete {
      position: absolute;
      cursor: pointer;
      z-index: 3;
      top: 8px;
      right: 8px;
      font-size: 14px;
      color: #F56C6C;
    }
  }
}
.click-bind-item {
  margin-top: 12px;
}
.click-bind-summary {
  margin: 0 0 4px;
}
</style>
